import styled from 'styled-components';
import { UnstyledButtonLink } from '../ButtonLink/ButtonLink';
import { ReactComponent as LoginIcon } from '../../assets/icons/login.svg';
import { ReactComponent as LogoutIcon } from '../../assets/icons/logout.svg';
import { useAuth } from "../../contexts/auth-context";
import { useLocation } from "react-router-dom";

const Flex = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 8px;
    margin-bottom: 32px;
`;

const LoginButton = styled(UnstyledButtonLink)`
    font-weight: var(--fw-regular);
    font-size: var(--fs-navigation-sub);
    color: var(--color-white);
    display: flex;
    align-items: center;
    gap: 8px;

    text-decoration: ${props => props.$active ? 'underline' : 'none'};
    text-underline-offset: 1.5px;
    
    svg {
        fill: var(--color-white);
        width: 20px;
        height: 20px;
    }
`;

const NavButton = styled(UnstyledButtonLink)`
    font-weight: var(--fw-medium);
    font-size: var(--fs-navigation-sub);
    color: var(--color-white);
    margin-right: 24px;
    text-decoration: ${props => props.$active ? 'underline' : 'none'};
    text-underline-offset: 1.5px;
    
    @media screen and (max-width: 475px) {
        margin-right: 12px;
    }
`;

const LoginBarMobile = ({ onClick }) => {
    const { logout, isAuthenticated } = useAuth();
    const {pathname} = useLocation();

    return (
        <Flex>
            { !isAuthenticated ? (
                <LoginButton to="/inloggen" $active={pathname === '/inloggen'} onClick={onClick}>
                    <LoginIcon />
                    Inloggen voor recruiters
                </LoginButton>
            ) : (
                <>
                    <NavButton to="/studenten" $active={pathname === '/studenten'} onClick={onClick}>
                        Studenten
                    </NavButton>
                    <LoginButton as="button" onClick={() => {logout(); onClick();}}>
                        <LogoutIcon />
                        Uitloggen
                    </LoginButton>
                </>
            )}
        </Flex>
    )
}

export default LoginBarMobile;